/** Local rows for Customer / Supplier Management while their APIs stay commented out. */

const hours = (days) =>
  days.map((day) => ({ dayRange: day, timeRange: { open: "09:00", close: "18:00" } }));

const record = (fields) => ({
  acceptTerms: true,
  partner_type: "",
  partnerTypeDetails: { value: "" },
  tenantDetails: { tenant_name: "Trangile" },
  moduleDetails: [],
  facilityDetails: [],
  documents: [],
  bank: { bankName: "", ifscCode: "", accountNumber: "" },
  operationalHours: hours(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]),
  status: 1,
  createdAt: "2026-01-12T09:30:00.000Z",
  updatedAt: "2026-03-04T11:15:00.000Z",
  userDetails: { username: fields.partner_email, password: "" },
  ...fields,
  address: {
    partner_address2: "",
    partner_country: "IN",
    partner_pincode: "",
    ...fields.address,
  },
});

export const CUSTOMER_DUMMY_LIST = [
  record({
    _id: "cust-1001",
    partner_id: "CUST-1001",
    partner_name: "Northwind Retail",
    partner_email: "ops@northwindretail.com",
    partner_mobile: "9876543210",
    partner_noOfUserLicenses: 12,
    address: { partner_address1: "14 MG Road", partner_city: "Bengaluru", partner_state: "Karnataka", partner_pincode: "560001" },
  }),
  record({
    _id: "cust-1002",
    partner_id: "CUST-1002",
    partner_name: "Harbor Home Stores",
    partner_email: "accounts@harborhome.com",
    partner_mobile: "9811122233",
    partner_noOfUserLicenses: 8,
    status: 2,
    address: { partner_address1: "22 Linking Road", partner_city: "Mumbai", partner_state: "Maharashtra", partner_pincode: "400050" },
  }),
  record({
    _id: "cust-1003",
    partner_id: "CUST-1003",
    partner_name: "Cedar & Co",
    partner_email: "hello@cedarco.in",
    partner_mobile: "9900011122",
    partner_noOfUserLicenses: 5,
    address: { partner_address1: "8 Park Street", partner_city: "Kolkata", partner_state: "West Bengal", partner_pincode: "700016" },
  }),
  record({
    _id: "cust-1004",
    partner_id: "CUST-1004",
    partner_name: "Lumen Electronics",
    partner_email: "procurement@lumenelec.com",
    partner_mobile: "9765432109",
    partner_noOfUserLicenses: 20,
    address: { partner_address1: "41 Anna Salai", partner_city: "Chennai", partner_state: "Tamil Nadu", partner_pincode: "600002" },
  }),
  record({
    _id: "cust-1005",
    partner_id: "CUST-1005",
    partner_name: "Greenfield Grocers",
    partner_email: "orders@greenfieldgrocers.com",
    partner_mobile: "9654321870",
    partner_noOfUserLicenses: 6,
    status: 3,
    address: { partner_address1: "5 Civil Lines", partner_city: "Jaipur", partner_state: "Rajasthan", partner_pincode: "302006" },
  }),
];

export const SUPPLIER_DUMMY_LIST = [
  record({
    _id: "sup-2001",
    partner_id: "SUP-2001",
    partner_name: "Apex Textiles",
    partner_email: "sales@apextextiles.com",
    partner_mobile: "9123456780",
    partner_noOfUserLicenses: 15,
    address: { partner_address1: "90 Ring Road", partner_city: "Surat", partner_state: "Gujarat", partner_pincode: "395002" },
  }),
  record({
    _id: "sup-2002",
    partner_id: "SUP-2002",
    partner_name: "BrightPack Industries",
    partner_email: "vendor@brightpack.in",
    partner_mobile: "9988776655",
    partner_noOfUserLicenses: 10,
    address: { partner_address1: "3 Industrial Area", partner_city: "Pune", partner_state: "Maharashtra", partner_pincode: "411019" },
  }),
  record({
    _id: "sup-2003",
    partner_id: "SUP-2003",
    partner_name: "Delta Components",
    partner_email: "support@deltacomponents.com",
    partner_mobile: "9012345678",
    partner_noOfUserLicenses: 7,
    status: 2,
    address: { partner_address1: "17 Nehru Place", partner_city: "New Delhi", partner_state: "Delhi", partner_pincode: "110019" },
  }),
  record({
    _id: "sup-2004",
    partner_id: "SUP-2004",
    partner_name: "Orbit Logistics Supply",
    partner_email: "desk@orbitlogistics.com",
    partner_mobile: "9345678120",
    partner_noOfUserLicenses: 18,
    address: { partner_address1: "55 NH Bypass", partner_city: "Hyderabad", partner_state: "Telangana", partner_pincode: "500032" },
  }),
  record({
    _id: "sup-2005",
    partner_id: "SUP-2005",
    partner_name: "Summit Raw Materials",
    partner_email: "hello@summitraw.com",
    partner_mobile: "9456123780",
    partner_noOfUserLicenses: 4,
    status: 3,
    address: { partner_address1: "2 Sector 18", partner_city: "Noida", partner_state: "Uttar Pradesh", partner_pincode: "201301" },
  }),
];

const SHIP_LOCATIONS = [
  { city: "Bengaluru", state: "Karnataka", zip: "560001", site: "Main Warehouse" },
  { city: "Mumbai", state: "Maharashtra", zip: "400050", site: "West Hub" },
  { city: "New Delhi", state: "Delhi", zip: "110019", site: "North Depot" },
  { city: "Chennai", state: "Tamil Nadu", zip: "600002", site: "South DC" },
];

/**
 * Dummy Ship To (customer) / Ship From (supplier) addresses for one partner row.
 * `keyField` is "shipTo" or "shipFrom"; the rest of the keys match the ship modal fields.
 */
export const buildDummyShipRows = (partnerRow, keyField = "shipTo") => {
  const code = partnerRow?.partner_id || partnerRow?._id || "PRT";
  const company = partnerRow?.partner_name || "";
  const prefix = keyField === "shipFrom" ? "SF" : "ST";

  return SHIP_LOCATIONS.map((loc, idx) => ({
    id: `${code}-${prefix}-${idx + 1}`,
    [keyField]: `${prefix}-${String(idx + 1).padStart(3, "0")}`,
    company: company ? `${company} - ${loc.site}` : loc.site,
    city: loc.city,
    state: loc.state,
    zip: loc.zip,
    accountingEntity: idx % 2 === 0 ? "AE-01" : "AE-02",
    cartonGroupOverride: idx === 1 ? "CG-LARGE" : "",
    outboundQcCheck: idx % 2 === 0 ? "Yes" : "No",
    defaultOutboundQcLocation: idx % 2 === 0 ? `QC-${loc.zip.slice(0, 3)}` : "",
  }));
};

/** Form payload → the same record shape the list table already reads. */
export const payloadToDummyRecord = (data, id) =>
  record({
    _id: id,
    partner_id: data.partner_id || "",
    partner_name: data.partner_name || "",
    partner_email: data.partner_email || "",
    partner_mobile: data.partner_mobile || "",
    partner_noOfUserLicenses: data.partner_noOfUserLicenses || "",
    acceptTerms: !!data.acceptTerms,
    status: data.status,
    bank: data.bank || {},
    operationalHours: data.operationalHours || [],
    documents: data.documents || [],
    userDetails: data.userDetails || {},
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    address: data.address || {},
  });
